module.exports = __webpack_public_path__ + "img/car_status_lost.602d512c.svg";